<template>
  <div class="select-rules-container">
    <h5 class="h6 font-weight-semibold mb-3">Rules</h5>
    <div
      class="d-flex align-items-start justify-content-end mb-2"
      v-for="(item, i) in selectedRules"
      :key="`course-url-${item.criteriaIdentifier}-${i}`"
    >
      <MultiSelectInput
        :ref="`identifierSelect${i}`"
        is-single
        no-clear-btn
        close-on-select
        class="mr-2 w-50"
        v-model="item.criteriaIdentifier"
        :options="criteriaIdOptions"
        placeholder="Select an option"
        :no-tracking="true"
        @input="resetSelectInputs(item)"
      ></MultiSelectInput>

      <MultiSelectInput
        :ref="`typeSelect${i}`"
        is-single
        no-clear-btn
        close-on-select
        class="mr-2 w-25"
        v-model="item.criteriaType"
        :options="$pfm.CRITERIA_TYPE_OPTIONS"
        track-by="value"
        label="label"
      ></MultiSelectInput>

      <MultiSelectInput
        :ref="`valueSelect${i}`"
        v-if="!isEmail(item.criteriaIdentifier)"
        class="mr-2 w-50"
        v-model="item.criteriaValues"
        :is-single="isSingle(item)"
        :no-clear-btn="isSingle(item)"
        :close-on-select="isSingle(item)"
        :options="criteriaValueOptions(item.criteriaIdentifier)"
        label="text"
        track-by="value"
        placeholder="Select an option"
      ></MultiSelectInput>

      <b-form-input
        v-else
        class="mr-2 w-50"
        type="text"
        v-model="item.criteriaValues"
      ></b-form-input>

      <div class="remove-btn-wrapper">
        <b-icon
          icon="x-circle-fill"
          variant="black"
          class="cursor-pointer opacity-50 my-2"
          @click="onDeleteRule(i)"
        ></b-icon>
      </div>
    </div>
    <b-icon
      icon="plus-circle-fill"
      variant="success"
      class="cursor-pointer"
      @click="onAddRule"
    ></b-icon>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import MultiSelectInput from '@/components/base/MultiSelectInput.vue';

export default {
  name: 'SelectRuleInput',
  props: {
    value: { type: Array, default: () => [] },
  },
  components: {
    MultiSelectInput,
  },
  data() {
    return {
      selectedRules: this.value,
    };
  },
  computed: {
    ...mapState('superAdmin', {
      proxyOrganizations: (s) => s.proxyOrganizations,
    }),
    criteriaIdOptions() {
      return Object.values(this.$pfm.CRITERIA_IDENTIFIER).map((x) => x.label);
    },
    isSingle() {
      return (rule) => {
        const selectedRule = this.selectedRules.find((r) => r == rule);
        return (
          selectedRule &&
          selectedRule.criteriaType?.value !== this.$pfm.CRITERIA_TYPE.INCLUDES
        );
      };
    },
    organizationOptions() {
      return this.proxyOrganizations.map((x) => ({
        value: x.id,
        text: x.name,
      }));
    },
    statusOptions() {
      return this.$pfm.STATUS_OPTION_LIST.map((x) => ({ ...x, value: x.name }));
    },
    criteriaValueOptions() {
      return (id) => {
        const rule = this.selectedRules.find(
          (x) => x.criteriaIdentifier === id
        );

        const { STATE, ROLE, ORGANIZATION, STATUS } =
          this.$pfm.CRITERIA_IDENTIFIER;

        if (rule) {
          if (rule.criteriaIdentifier === STATE.label) {
            return this.$pfm.STATES;
          } else if (rule.criteriaIdentifier === ROLE.label) {
            return this.$pfm.ROLE_OPTIONS;
          } else if (rule.criteriaIdentifier === STATUS.label) {
            return this.statusOptions;
          } else if (rule.criteriaIdentifier === ORGANIZATION.label) {
            return this.organizationOptions;
          }
        }
        return [];
      };
    },
  },
  validations: {
    selectedRules: {
      $each: {
        criteriaIdentifier: { required },
        criteriaType: { required },
        criteriaValues: { required },
      },
    },
  },
  methods: {
    isEmail(rule) {
      return rule === this.$pfm.CRITERIA_IDENTIFIER.EMAIL.label;
    },
    onAddRule() {
      const selectedIds = this.selectedRules.map((x) => x.criteriaIdentifier);
      const remainingIds = this.criteriaIdOptions.filter(
        (x) => !selectedIds.includes(x.value)
      );
      if (!remainingIds.length) return;
      this.selectedRules.push({
        criteriaIdentifier: null,
        criteriaType: null,
        criteriaValues: '',
      });
      this.$emit('input', this.selectedRules);
    },
    onDeleteRule(idx) {
      this.selectedRules.splice(idx, 1);
      this.$emit('input', this.selectedRules);
    },
    resetSelectInputs(selectedType) {
      this.$set(selectedType, 'criteriaType', {});
      this.$set(selectedType, 'criteriaValues', '');
    },
  },
};
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

.select-rules-container {
  .multiselect {
    .multiselect__tags {
      border: 1px solid $separator-border-color;
    }

    .multiselect__input,
    .multiselect__single {
      margin-bottom: 0;
    }
    .multiselect__content-wrapper {
      top: auto;
    }
  }

  input.form-control,
  .remove-btn-wrapper {
    height: calc(1.5em + 0.75rem);
  }
}
</style>
